"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[652],{

/***/ 90652:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ FlightTravelerBlock; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var _emotion_react__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(70917);
/* harmony import */ var react_hook_form__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(87536);
/* harmony import */ var react_i18next__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(26793);
/* harmony import */ var main_javascripts_components_form_SelectBlock__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(14864);
/* harmony import */ var main_javascripts_utils_ArrayUtil__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(77562);
/* harmony import */ var main_javascripts_styles_base_spaceStyle__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(96749);
/* harmony import */ var main_javascripts_styles_base_responsiveStyle__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(88433);
/* harmony import */ var _constants_FormConstants__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(36581);
/* harmony import */ var _emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(35944);
function _EMOTION_STRINGIFIED_CSS_ERROR__() { return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop)."; }












var FlightTravelerBlock = function FlightTravelerBlock(props) {
  var labelColorStyleKey = props.labelColorStyleKey,
      borderColorStyleKey = props.borderColorStyleKey;

  var _useTranslation = (0,react_i18next__WEBPACK_IMPORTED_MODULE_5__/* .useTranslation */ .$)(["label"]),
      t = _useTranslation.t;

  var MAX_ADULT_NUM = 8;
  var MAX_CHILD_NUM = 8;
  var MAX_CHILD_AGE = 11;

  var _useFormContext = (0,react_hook_form__WEBPACK_IMPORTED_MODULE_6__/* .useFormContext */ .Gc)(),
      setValue = _useFormContext.setValue,
      errors = _useFormContext.formState.errors;

  var values = (0,react_hook_form__WEBPACK_IMPORTED_MODULE_6__/* .useWatch */ .qo)();

  var _useFieldArray = (0,react_hook_form__WEBPACK_IMPORTED_MODULE_6__/* .useFieldArray */ .Dq)({
    name: "traveler.ages_of_children"
  }),
      fields = _useFieldArray.fields,
      append = _useFieldArray.append,
      remove = _useFieldArray.remove;

  var valuesRef = (0,react__WEBPACK_IMPORTED_MODULE_0__.useRef)(values);
  valuesRef.current = values;

  var renderChildAge = function renderChildAge(index) {
    var fieldName = "traveler.ages_of_children.".concat(index, ".age");
    var optionList = [(0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_7__/* .jsx */ .tZ)("option", {
      value: "",
      disabled: true,
      children: "\u5E74\u9F62"
    }, "none")]; // const { ageInputStyle, ageInputMultiStyle, labelAgeStyle } = styles;
    //
    // const propStyle: any =
    //   Number(values.flightTraveler_num || 1) === 1
    //     ? ageInputStyle
    //     : ageInputMultiStyle;
    // tslint:disable-next-line:prefer-array-literal

    Array.from(Array(MAX_CHILD_AGE + 1).keys()).map(function (childAge) {
      optionList.push((0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_7__/* .jsx */ .tZ)("option", {
        value: childAge,
        children: "".concat(childAge, " \u6B73")
      }, childAge));
    });
    return (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_7__/* .jsx */ .tZ)(main_javascripts_components_form_SelectBlock__WEBPACK_IMPORTED_MODULE_1__/* .SelectBlock */ .w, {
      namespace: _constants_FormConstants__WEBPACK_IMPORTED_MODULE_4__/* .FormNamespaces.flight */ .Z.flight,
      // styles={[
      //   FlightTravelerBlockStyle.flightTravelerInputBlockSmall,
      //   propStyle,
      // ]}
      label: {
        namespace: "common",
        label: t("label:common.flightAgesOfChildren", {
          index: Number(index) + 1
        }),
        colorStyleKey: labelColorStyleKey // styles: [FlightTravelerBlockStyle.childLabel, labelAgeStyle],

      },
      select: {
        name: fieldName,
        children: optionList
      },
      error: (0,react_hook_form__WEBPACK_IMPORTED_MODULE_6__/* .get */ .U2)(errors, fieldName),
      borderColorStyleKey: borderColorStyleKey
    }, index);
  };

  var renderNumberOfChildren = function renderNumberOfChildren() {
    var fieldName = "traveler.number_of_children";
    var optionList = []; // tslint:disable-next-line:prefer-array-literal

    Array.from(Array(MAX_CHILD_NUM + 1 - (values.traveler.number_of_adult || 0)).keys()).map(function (childNum) {
      optionList.push((0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_7__/* .jsx */ .tZ)("option", {
        value: childNum,
        children: "".concat(childNum, " \u4EBA")
      }, childNum));
    });
    return (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_7__/* .jsx */ .tZ)("div", {
      css: flightTravelerInputBlockStyle,
      children: (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_7__/* .jsx */ .tZ)(main_javascripts_components_form_SelectBlock__WEBPACK_IMPORTED_MODULE_1__/* .SelectBlock */ .w, {
        namespace: _constants_FormConstants__WEBPACK_IMPORTED_MODULE_4__/* .FormNamespaces.flight */ .Z.flight,
        label: {
          namespace: "common",
          label: t("label:common.flightNumberOfChildren"),
          colorStyleKey: labelColorStyleKey
        },
        select: {
          name: fieldName,
          onChange: onChangeNumberOfChildren(),
          children: optionList
        },
        error: (0,react_hook_form__WEBPACK_IMPORTED_MODULE_6__/* .get */ .U2)(errors, fieldName),
        borderColorStyleKey: borderColorStyleKey
      })
    });
  };

  var renderNumberOfAdult = function renderNumberOfAdult() {
    var fieldName = "traveler.number_of_adult";
    var optionList = []; // tslint:disable-next-line:prefer-array-literal

    Array.from(Array(MAX_ADULT_NUM - (values.traveler.number_of_children || 0)).keys()).map(function (adultNum) {
      optionList.push((0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_7__/* .jsx */ .tZ)("option", {
        value: adultNum + 1,
        children: "".concat(adultNum + 1, " \u4EBA")
      }, adultNum));
    });
    return (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_7__/* .jsx */ .tZ)("div", {
      css: flightTravelerInputBlockStyle,
      children: (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_7__/* .jsx */ .tZ)(main_javascripts_components_form_SelectBlock__WEBPACK_IMPORTED_MODULE_1__/* .SelectBlock */ .w, {
        namespace: _constants_FormConstants__WEBPACK_IMPORTED_MODULE_4__/* .FormNamespaces.flight */ .Z.flight,
        label: {
          namespace: "common",
          label: t("label:common.flightNumberOfAdult"),
          colorStyleKey: labelColorStyleKey
        },
        select: {
          name: fieldName,
          children: optionList
        },
        error: (0,react_hook_form__WEBPACK_IMPORTED_MODULE_6__/* .get */ .U2)(errors, fieldName),
        borderColorStyleKey: borderColorStyleKey
      })
    });
  }; // useFieldArrayではオブジェクト単位で追加する必要があり
  // indexで終わるkeyに対して値を追加できないため
  // .ageで管理し、リクエスト時に整形する


  var onChangeNumberOfChildren = function onChangeNumberOfChildren() {
    return function (e) {
      var oldNumberOfChildren = parseInt(valuesRef.current.traveler.number_of_children, 10);
      var numberOfChildren = parseInt(e.target.value, 10);
      setValue("traveler.number_of_children", numberOfChildren);

      if (oldNumberOfChildren > numberOfChildren) {
        remove((0,main_javascripts_utils_ArrayUtil__WEBPACK_IMPORTED_MODULE_8__/* .rangexy */ .w)(numberOfChildren, oldNumberOfChildren));
      } else if (oldNumberOfChildren < numberOfChildren) {
        (0,main_javascripts_utils_ArrayUtil__WEBPACK_IMPORTED_MODULE_8__/* .rangexy */ .w)(oldNumberOfChildren, numberOfChildren).map(function (_) {
          append({
            age: ""
          }, {
            shouldFocus: false
          });
        });
      }
    };
  };

  return (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_7__/* .jsx */ .tZ)("div", {
    css: flightTravelerBlockStyle,
    children: (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_7__/* .jsxs */ .BX)("div", {
      css: flightTravelerInputGroupBlockStyle,
      children: [(0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_7__/* .jsxs */ .BX)("div", {
        css: flightTravelerInputGroupBlockMediumStyle,
        children: [renderNumberOfAdult(), renderNumberOfChildren()]
      }), (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_7__/* .jsx */ .tZ)("div", {
        css: flightTravelerInputGroupBlockStyle,
        children: fields.map(function (field, index) {
          return (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_7__/* .jsx */ .tZ)("div", {
            css: flightTravelerInputBlockSmallStyle,
            children: renderChildAge(index)
          }, field.id);
        })
      })]
    })
  });
};
var flightTravelerBlockStyle = /*#__PURE__*/(0,_emotion_react__WEBPACK_IMPORTED_MODULE_9__.css)("display:flex;flex-wrap:wrap;padding:", main_javascripts_styles_base_spaceStyle__WEBPACK_IMPORTED_MODULE_2__/* .space.atom */ .D.atom, " 0;" + ( true ? "" : 0),  true ? "" : 0);
var flightTravelerInputGroupBlockStyle =  true ? {
  name: "798ujy",
  styles: "width:100%;display:flex;flex-wrap:wrap"
} : 0;
var flightTravelerInputBlockStyle =  true ? {
  name: "1t29t6p",
  styles: "width:50%"
} : 0;
var flightTravelerInputGroupBlockMediumStyle =  true ? {
  name: "do4vze",
  styles: "width:66.666%;display:flex"
} : 0;
var flightTravelerInputBlockSmallStyle = /*#__PURE__*/(0,_emotion_react__WEBPACK_IMPORTED_MODULE_9__.css)("width:33.333%;", (0,main_javascripts_styles_base_responsiveStyle__WEBPACK_IMPORTED_MODULE_3__/* .moreThanBreakpoint */ .h6)("tablet"), "{width:25%;}" + ( true ? "" : 0),  true ? "" : 0);

/***/ })

}]);